import "./es.array.map-d821aaf5.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.is-array-7a29277f.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-json-b76d522e.js";
import "./es.object.keys-9d66766f.js";
import "./es.object.to-string-f55666a8.js";
import "./es.parse-int-d7709701.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.iterator-5de8a61e.js";
import "./index-5d0f31c6.js";
var D = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], c = [{
  name: "Sunday",
  short: "S",
  isWeekend: !0
}, {
  name: "Monday",
  short: "M"
}, {
  name: "Tuesday",
  short: "T"
}, {
  name: "Wednesday",
  short: "W"
}, {
  name: "Thursday",
  short: "T"
}, {
  name: "Friday",
  short: "F"
}, {
  name: "Saturday",
  short: "S",
  isWeekend: !0
}], V = 100, B = 50, h = "SINGLE_DATE", v = "RANGE", d = "MUTLI_DATE", J = function(e, n) {
  return Array.from(Array(e).keys()).map(function(a) {
    return {
      value: a + 1,
      id: n + "-" + a
    };
  });
}, j = function(e, n) {
  return !e || !n ? !1 : e.day === n.day && e.month === n.month && e.year === n.year;
}, q = function(e) {
  return Object.assign({}, e);
}, z = function(e) {
  return JSON.parse(JSON.stringify(e, function(n, a) {
    return typeof a > "u" ? null : a;
  }));
}, X = function(e, n) {
  var a = n === "NEXT" ? 1 : -1, t = e.month + a, r = e.year;
  t < 1 && (t = 12, r -= 1), t > 12 && (t = 1, r += 1);
  var o = {
    year: r,
    month: t,
    day: 1
  };
  return o;
}, u = function(e, n) {
  return Object.prototype.hasOwnProperty.call(e || {}, n);
}, Z = function(e) {
  if (Array.isArray(e))
    return d;
  if (u(e, "from") && u(e, "to"))
    return v;
  if (!e || u(e, "year") && u(e, "month") && u(e, "day") || typeof e == "string")
    return h;
  throw new TypeError("The passed value is malformed! Please make sure you're using one of the valid value types for date picker.");
}, S = function(e) {
  return e && e[0].toUpperCase() + e.slice(1) || "";
}, T = function(e, n) {
  n === void 0 && (n = !1);
  var a = e.replace(new RegExp("/", "g"), "").replace(new RegExp(" ", "g"), "");
  if (!/^\d+$/g.test(a))
    return "";
  var t = a.substring(0, 2), r = a.substring(2, 4), o = a.substring(4, 8);
  t && (t.length === 2 && +t == 0 ? t = "01" : +t > 12 && (t = "0" + t.substring(0, 1), r = a.substring(1, 3), o = a.substring(3, 7))), r && (r.length === 2 && +r == 0 ? r = "01" : +r > 31 && (o = r.substring(1, 2) + o.substring(0, 3), r = "0" + r.substring(0, 1)));
  var s = "" + t + (r && " / " + r) + (o && " / " + o);
  return n ? {
    month: t,
    day: r,
    year: o
  } : s;
}, f = function(e, n, a, t) {
  if (t === void 0 && (t = !0), !a)
    return "";
  var r = new Date(a.year, a.month - 1, a.day), o = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  }, s = e || o;
  return r.toLocaleDateString(t ? n : "en-US", t ? s : o).replace(new RegExp("/", "g"), " / ");
}, H = function(e, n, a, t, r) {
  if (!r.from || !r.to)
    return "";
  var o = r.from, s = r.to, m = new Date(o.year, o.month - 1, o.day), l = new Intl.DateTimeFormat("en-US").format(m).toString(), y = new Date(s.year, s.month - 1, s.day), p = new Intl.DateTimeFormat("en-US").format(y).toString();
  return a + " " + l + " " + t + " " + p;
}, K = function(e, n) {
  if (!e)
    return {
      formatted: "",
      default: "",
      native: /* @__PURE__ */ new Date()
    };
  var a = e, t = a.month, r = a.day, o = a.year, s = f(n, "en-US", {
    month: t,
    day: r,
    year: o
  }), m = f(null, "en-US", {
    month: t,
    day: r,
    year: o
  });
  return {
    formatted: s,
    default: m,
    native: new Date(o, t - 1, r)
  };
}, $ = function(e, n) {
  n === void 0 && (n = !1);
  var a = T(e, !0), t = a.month, r = a.day, o = a.year;
  if (t && r && o && o.length === 4 && +o > 1e3) {
    var s = new Date(o, t - 1, r);
    return s.getMonth() + 1 !== parseInt(t) || s.getDate() !== parseInt(r) || s.getFullYear() !== parseInt(o) ? null : n ? {
      month: +t,
      day: +r,
      year: +o
    } : {
      month: t,
      day: r,
      year: o
    };
  }
  return null;
}, g = {
  weekStartingIndex: 0,
  getToday: function(e) {
    return e;
  },
  toNativeDate: function(e) {
    return new Date(e.year, e.month - 1, e.day);
  },
  getMonthLength: function(e) {
    return new Date(e.year, e.month, 0).getDate();
  },
  transformDigit: function(e) {
    return e;
  },
  nextMonth: "Next Month",
  previousMonth: "Previous Month",
  openMonthSelector: "Open Month Selector",
  openYearSelector: "Open Year Selector",
  closeMonthSelector: "Close Month Selector",
  closeYearSelector: "Close Year Selector",
  from: "from",
  to: "to",
  defaultPlaceholder: "MM / DD / YYYY",
  defaultLabel: "Select Date",
  digitSeparator: ",",
  yearLetterSkip: 0,
  isRtl: !1
};
Object.assign({
  months: D,
  weekDays: c
}, g);
var M = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], A = function(e, n) {
  e === void 0 && (e = "en-US"), n === void 0 && (n = "long");
  var a = new Intl.DateTimeFormat(e, {
    month: n,
    timeZone: "America/Los_Angeles"
  }).format;
  return M.map(function(t) {
    return S(a(new Date(Date.UTC(2021, (t + 1) % 12))));
  });
}, E = [0, 1, 2, 3, 4, 5, 6], w = function(e, n) {
  e === void 0 && (e = "es-US"), n === void 0 && (n = "long");
  var a = new Intl.DateTimeFormat(e, {
    weekday: n,
    timeZone: "America/Los_Angeles"
  }).format;
  return E.map(function(t) {
    var r = a(new Date(Date.UTC(2021, 10, t + 1)));
    return {
      name: a(new Date(Date.UTC(2021, 10, t + 1))),
      short: r.charAt(0).toUpperCase(),
      isWeekend: t === 0 || t === 6
    };
  });
}, Q = function(e) {
  return typeof e == "string" ? Object.assign({
    months: A(e),
    weekDays: w(e)
  }, g) : e;
};
export {
  V as M,
  v as T,
  H as a,
  h as b,
  f as c,
  d,
  X as e,
  T as f,
  Z as g,
  K as h,
  Q as i,
  J as j,
  j as k,
  z as l,
  B as m,
  q as s,
  $ as v
};
